export function hasConfiguredCustomDomain(customDomain?: { domain?: string | null } | null): boolean {
  return Boolean(customDomain?.domain)
}
